"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var globalAny = global;
var TriSnackBarWidget_1 = __importDefault(require("./TriSnackBarWidget/TriSnackBarWidget"));
globalAny.TriSnackBarWidget = TriSnackBarWidget_1.default;
exports.default = globalAny;
